const DOCUMENT_INSURANCE_TYPE = "Insurance";

function appendDocument(acc, doc) {
  if (!doc?.key || !doc?.type) {
    return acc;
  }

  const entry = {
    key: doc.key,
    name: doc.name,
    qualification_type: doc.qualification_type ?? ""
  };

  if (Object.prototype.hasOwnProperty.call(acc, doc.type)) {
    return {
      ...acc,
      [doc.type]: [...acc[doc.type], entry]
    };
  }

  return {
    ...acc,
    [doc.type]: [entry]
  };
}

export default function buildPractitionerApplicationDocuments(documents, insuranceEvidence) {
  const allDocuments = Array.isArray(documents) ? [...documents] : [];

  if (insuranceEvidence?.key) {
    const hasInsurance = allDocuments.some(
      doc => doc.type === DOCUMENT_INSURANCE_TYPE && doc.key === insuranceEvidence.key
    );
    if (!hasInsurance) {
      allDocuments.push({
        key: insuranceEvidence.key,
        name: insuranceEvidence.name,
        type: DOCUMENT_INSURANCE_TYPE,
        qualification_type: ""
      });
    }
  }

  const payload = allDocuments.reduce((acc, doc) => appendDocument(acc, doc), {});

  return JSON.stringify(payload);
}
